module.exports = __webpack_public_path__ + "media/images/pt/your_approachto_mindsetting-642cfacb392024fb9040415d1e221378.png";